module.exports = __webpack_public_path__ + "static/media/awaiver-logo.1da9ee62.svg";